
import { Component, OnInit, Input } from '@angular/core';
import { FlexModule } from '@angular/flex-layout';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatSliderModule } from '@angular/material/slider';

@Component({
    selector: 'topo-slider',
    imports: [MatSliderModule, FlexModule],
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: SliderComponent
        }
    ]
})
export class SliderComponent implements OnInit, ControlValueAccessor {
  value: number = 0;
  @Input() default: number = 0;
  @Input() unsetValue: number = null;
  @Input() valueArray: any[];
  @Input() min: number = 1;
  @Input() max: number = 100;
  @Input() tickInterval: 'auto' | number = 'auto';
  @Input() step: number = 1;
  @Input() label: string;
  @Input() valueDisplayFormatter: (value) => string;
  public displayValue = '';
  protected isDragging = false;

  // Value Accessor Implmentation
  onChange = value => {};
  onTouched = () => {};
  touched = false;
  disabled = false;

  constructor() {}

  ngOnInit(): void {
    this.showNewValue(this.value);
  }

  onValueChange(_value: number) {
    const value = _value === this.unsetValue ? null : _value;
    if (this.onChange) {
      if (this.valueArray && value !== null) {
        this.onChange(this.valueArray[value]);
        return;
      }
      this.onChange(value);
    }
  }

  onValueInput(e: InputEvent) {
    const { valueAsNumber } = e.target as HTMLInputElement;
    this.showNewValue(valueAsNumber);
    this.markAsTouched();
  }

  showNewValue(value: number) {
    if (this.valueDisplayFormatter) {
      this.displayValue = this.valueDisplayFormatter(value);
      return;
    }
    this.displayValue = `${value}`;
  }

  // Value Accessor Implmentation
  writeValue(value: any): void {
    if (this.valueArray) {
      this.value = value === null ? this.valueArray[this.default] : this.valueArray.findIndex(v => v === value);
    } else {
      this.value = value === null || value === undefined ? this.default : value;
    }
    this.showNewValue(this.value);
  }
  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }
  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  markAsTouched() {
    if (!this.touched) {
      if (this.onTouched) {
        this.onTouched();
      }
      this.touched = true;
    }
  }
}
